import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { setupDxLicense } from 'sham-configs';

setupDxLicense();
bootstrapApplication(App, appConfig).catch((err) => console.error(err));
